export const headers = [
  { text: '', width: 1, key: 'offCanvas' },
  { text: 'ID', width: 2, key: 'id' },
  { text: 'Nº Item', width: 4, key: 'numeroItem' },
  // { text: 'Nº Plano Ação', width: 5, key: 'numeroPa' },
  { text: 'Data Prevista', width: 5, key: 'dataPrevista' },
  { text: 'Produto Farmacêutico', width: 30, key: 'produtoFarmaceutico' },
  { text: 'Qtd Total', width: 5, key: 'qtdTotal' },
  { text: 'Valor Total', width: 5, key: 'valorTotal' },
];

export const valoresExibidos: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Data de Registro',
  dataAtualizacao: 'Última Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  dataUltimaAtualizacao: 'Última Atualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  usuarioRegistro: 'Responsável pelo Registro',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  observacoes: 'Observações',

  // Fase
  actId: 'ID do Act',
  actLabel: 'Nº do ACT',
  numeroItem: 'Nº do Item',
  dataPrevista: 'Data Prevista',
  qtdAdministrativa: 'Qtd Administrativa',
  qtdEstrategico: 'Qtd Estratégico',
  qtdJudicial: 'Qtd Judicial',
  qtdOutro: 'Qtd Outro',
  qtdTotal: 'Qtd Total',
  embalagemFator: 'Fator Embalagem',
  embalagemTotal: 'Total de Embalagens',
  valorUnitHomologado: 'Valor Unit. R$',
  valorReequilibrioBin: 'Valor Reequilíbrio?',
  valorUnitReequilibrio: 'Valor Unit. Reeq. R$',
  valorTotal: 'Valor Total R$',

  //Separadores
  separador: '',
  separadorLog: '',
  separador1: '',
  separador2: '',
  separador3: '',
  separador4: '',
  separador5: '',
};

export const fieldObjectProaq = [
  'usuarioRegistro.nomeCompleto',
  'usuarioAtualizacao.nomeCompleto',
  'usuarioUltimaVisualizacao.nomeCompleto',
  'responsavel.nomeCompleto',
  'proaq.id',
  'proaqResponsavel.responsavel',
  'produtoDAF.produtoFarmaceutico',
  'denominacaoGenerica.denominacaoGenerica',
  'KitProdutoDAF.nomeKit',
];
